import './polyfills';

import 'primeng/resources/primeng.min.css';
import 'primeng/resources/themes/omega/theme.css';
import './assets/global.css';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { AppModule } from './app/app.module';
import { environment as dev} from './environments/environment.dev';
import { environment as prod } from './environments/environment.prod';

declare const process: {
	env: {
		NODE_ENV: string
	}
};

const environment: any = process.env.NODE_ENV === 'production' ? prod : dev;

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts